import { Component, OnInit } from '@angular/core';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { BaseFormControlComponent } from '../../../classes/base-form-control.component';
import {TooltipComponent} from "../../../../../../shared/components/ui/tooltip/tooltip.component";
import { TranslatePipe } from '../../../../../../shared/pipes/translate/translate.pipe';
import { PopupComponent } from 'src/app/shared/components/ui/popup/popup.component';
/**
 * Represent a control that allows the user to select a boolean value with a checkbox.
 */
@Component({
  selector: 'bizz-checkbox-control',
  standalone: true,
  imports: [CheckBoxModule, ReactiveFormsModule, NgClass, AsyncPipe, TooltipComponent, TranslatePipe, PopupComponent],
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['./checkbox-control.component.scss']
})
export class CheckboxControlComponent extends BaseFormControlComponent implements OnInit {
  protected override focus(): void {
    // Add your implementation here
  }
}
